<template>
  <CustomPicker
    multiple
    title="questionText"
    :selectable="selectable"
    :isLoading="isLoading"
    :inputLabel="inputLabel"
    :isInDialog="isInDialog"
    :closeOnSelect="false"
    v-model="selectedQuestions"
    :items="questionList"
  ></CustomPicker>
</template>

<script>
export default {
  emits: ["getQuestions"],
  props: {
    defaultSelectedQuestions: {
      type: Array,
      required: false,
    },
    selectable: {
      type: Function,
      default: () => true,
    },
    inputLabel: {
      type: String,
      default: "سوال های مورد نظر را انتخاب کنید",
    },
    isInDialog: {
      type: Boolean,
      default: false,
    },
    selectedLessonId: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  watch: {
    defaultSelectedQuestions: {
      handler(val) {
        if (val) {
          this.selectedQuestions = val;
        }
      },
      immediate: true,
    },
    selectedLessonId: {
      handler(val) {
        this.questionsListFilter.lessonId = val;
        this.getAllQuestions();
      },
      immediate: true,
    },
    selectedQuestions: {
      handler(val) {
        this.$emit("getQuestions", val);
      },
    },
  },
  mounted() {
    this.getAllQuestions();
  },
  data() {
    return {
      isLoading: false,
      questionList: null,
      totalCount: null,
      selectedQuestions: [],
      questionsListFilter: {
        count: 30,
        pageNumber: 1,
        searchCommand: null,
        lessonId: null,
      },
    };
  },
  methods: {
    async getAllQuestions() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllQuestions = new GetAllQuestions(_this);
        getAllQuestions.setRequestParam(_this.questionsListFilter);
        await getAllQuestions.fetch((res) => {
          _this.questionList = res.data.questions;
          _this.totalCount = res.data.questionsCount;
        });
      } catch (error) {
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    CustomPicker,
  },
};
import CustomPicker from "@/views/components/Utils/CustomPicker.vue";
import { GetAllQuestions } from "@/libs/Api/Question";
</script>
